<template>
  <div>
    <!--    <v-system-bar dark color="primary">-->
    <!--      <v-spacer></v-spacer>-->
    <!--      <span class="info">{{getId}} - {{getLogin}}</span>-->
    <!--    </v-system-bar>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserBar',
  data: () => ({}),
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
    }),
  },
  methods: {
    ...mapActions({}),

    toggle_dark_mode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString())
    },
  },
  async mounted() {},
}
</script>
